<template>
  <Layout :footer-style="2" header-class="header-left-align" nav-alignment="right" :header-transparency="false" :show-top-header="true" buy-button-class="btn-default btn-small">

    <!-- Start Brand Area  -->
    <div class="rwt-brand-area rn-section-gap">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <SectionTitle
                subtitle="YAO XIE GONG MAO"
                text-align="center"
                title="售后服务保障"
                data-aos="fade-up"
            />
          </div>


          <div class="col-lg-12">
            <div class="thumbnail text-center" data-aos="fade-up">
              <img class="radius w-80 " src="../../assets/images/product/aftersale-01.jpg" alt="Images"/>
            </div>
          </div>



        </div>
      </div>
    </div>
    <!-- End Brand Area  -->

  </Layout>
</template>

<script>
import Layout from "../../components/common/Layout";
import SectionTitle from "../../components/elements/sectionTitle/SectionTitle";

export default {
  name: "ProductAfterSales",
  components: {Layout,SectionTitle},
}
</script>

<style scoped>

</style>